import React from "react";
import * as W from "./WarningTransparenciaStyle";
import { FaBullhorn } from "react-icons/fa";

export default function WarningTransparencia({ onClose }) {
  return (
    <W.WarningOverlay>
      <W.WarningContainer>
        <W.TopAccent />

        <W.Header>
          <W.IconCircle>
            <FaBullhorn />
          </W.IconCircle>
          <W.Badge>Comunicado</W.Badge>
          <W.Title>Comunicado Oficial</W.Title>
          <W.Subtitle>Transparência, Segurança e Regularização</W.Subtitle>
          <W.Divider />
          <W.Assunto>
            <strong>Assunto:</strong> Esclarecimentos sobre Gestão Interna e
            Cronograma de Regularização de Pagamentos
          </W.Assunto>
        </W.Header>

        <W.Body>
          <W.TextContent>
            <W.Greeting>Prezado(a) Cliente,</W.Greeting>

            <p>
              A Golden Brasil pauta sua trajetória pela transparência absoluta
              com seus parceiros.
            </p>

            <p>
              Por este motivo, escrevemos para informá-los sobre os recentes
              desafios enfrentados por nossa gestão e, principalmente, sobre as
              medidas robustas que garantem a segurança do seu capital.
            </p>

            <W.SectionTitle>1. Transparência sobre Desvios</W.SectionTitle>

            <p>
              Identificamos recentemente divergências relacionadas a pagamentos
              realizados em nossa estrutura interna. Após auditoria preliminar,
              constatou-se que parte dessas ocorrências decorreu de
              procedimentos adotados pela gestão anterior e parte envolveu
              situações em que determinados clientes receberam ou buscaram
              receber valores superiores aos previstos contratualmente,
              atualmente em processo de apuração e regularização.
            </p>

            <p>
              Gostaríamos de enfatizar que todas as medidas administrativas,
              jurídicas e de compliance já foram adotadas para apurar os fatos,
              corrigir as inconsistências identificadas e fortalecer nossos
              controles internos, garantindo maior segurança, transparência e
              conformidade em todas as operações da empresa.
            </p>

            <W.SectionTitle>
              2. A Garantia do seu Capital: Lastro Real
            </W.SectionTitle>

            <p>
              É fundamental destacar que, apesar deste contratempo
              administrativo, a solidez patrimonial da empresa permanece
              intacta. O que diferencia a Golden Brasil de qualquer estrutura
              especulativa é o nosso lastro em ativos reais.
            </p>

            <p>
              Nossas reservas minerais (pedras preciosas, diamantes, joias,
              minérios diversos, títulos da Petrobras, máquinas e
              equipamentos), bem como nossas propriedades e ativos
              imobiliários, superam o valor total das obrigações com nossos
              clientes. Este patrimônio físico e auditável atua como uma{" "}
              <strong>garantia real e inabalável</strong>, resguardando
              integralmente o seu capital aportado.
            </p>

            <W.SectionTitle>3. Plano de Regularização</W.SectionTitle>

            <p>
              Estamos trabalhando intensamente na reorganização do nosso fluxo
              de caixa para sanar os atrasos decorrentes do problema
              mencionado. Estabelecemos um cronograma claro e realista:
            </p>

            <W.Highlight>
              <strong>Prazo Previsto de Regularização:</strong> a previsão do
              final da auditoria é de até o final de Setembro, onde em live ao
              vivo será apresentado o resultado e o cronograma de pagamentos.
            </W.Highlight>

            <p>
              Este período é necessário para que possamos realizar a
              liquidação estratégica de ativos e o reajuste operacional,
              garantindo que todos recebam seus valores com a devida segurança
              jurídica e financeira.
            </p>

            <W.SectionTitle>4. Conclusão</W.SectionTitle>

            <p>
              Problemas de gestão podem ocorrer em qualquer grande corporação,
              mas o que define a segurança do seu aporte é o que está por trás
              dele. Na Golden Brasil o que sustenta não são apenas números em
              uma tela, mas <strong>pedras preciosas, minérios, terras e
              produção mineral real</strong>.
            </p>

            <p>
              Agradecemos a compreensão e a paciência neste momento de
              transição. Nossa diretoria permanece à disposição para
              esclarecimentos adicionais e reafirma o compromisso inabalável
              com a entrega de resultados e a proteção do seu patrimônio.
            </p>

            <W.Signature>
              Atenciosamente,
              <strong>Golden Brasil</strong>
            </W.Signature>
          </W.TextContent>
        </W.Body>

        <W.Footer>
          <W.AcceptButton onClick={onClose}>Estou ciente</W.AcceptButton>
        </W.Footer>
      </W.WarningContainer>
    </W.WarningOverlay>
  );
}
